import ReadMore from '@stories/Components/Buttons/ReadMore/ReadMore';
import * as React from 'react';
import S from './RichText.styles';
const RichText = (props) => {
    const [isClosed, setIsClosed] = React.useState(true);
    return (React.createElement(S.Container, { id: props.anchorId, spacing: "padding", "data-layout": props.layout, "data-theme": props.theme },
        props.title && (React.createElement(S.Title, { ...(props.titleType === 'h1' ? { as: 'h1' } : {}) },
            React.createElement("span", null, props.title))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Content, { "data-read-more": props.showReadMore && isClosed ? 'closed' : 'open', dangerouslySetInnerHTML: { __html: props.content } }),
            props.showReadMore && (React.createElement(ReadMore, { expanded: !isClosed, onClick: () => {
                    setIsClosed(!isClosed);
                } })))));
};
export default RichText;
